import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { TransportOptionsPanelModel } from '../../transport-options-panel.model';



@Component({
  selector: 'app-transport-options-panel',
  templateUrl: './transport-options-panel.component.html',
  styleUrls: ['./transport-options-panel.component.scss']
})
export class TransportOptionsPanelComponent implements OnInit {

  @Input() model: TransportOptionsPanelModel;

  @Input() showInternalTransportOptions = true;

  @Input() showDriverHints = false;

  constructor(
    public translationService: TranslationService
  ) {

  }

  ngOnInit(): void {

  }

}
